import React, { FC, useContext, useState } from 'react';

import { navigate } from '@reach/router';

import { GlobalContext } from '../../../../store';
import { IGame, IGroupGameGame } from '../../../../store/player/games/store';

import Button from '../../../../components/Button';
import { useRouteInfoState } from '../../../../components/RouteInfo/Context/RouteInfo.context';
import Scorer from '../Components/Scorer';
import { useSortedGroupGames } from '../Utils/useSortedGroupEnrollments';
import { ScorersContainer } from './SetMoneyBallOrder.Styles';
import { useShotgunGameMetadata } from '../../ClubHome/CurrentEvent/Components/CurrentEventTeeTimeParings/useShotgunGameMetadata';

const SetMoneyBallOrder: FC = () => {
  const {
    actions: {
      games: { swapPlayersSeats, getAllGames }
    },
    games
  } = useContext(GlobalContext);

  const { eventId, roundId } = useRouteInfoState();

  const currentGame: IGame = Object.values(games).find(game => game.round.id === Number(roundId));
  const [, groupGames] = useSortedGroupGames(currentGame);
  const [gameToSwap, setGameToSwap] = useState<IGroupGameGame>();

  const { isShotgun, startingHole } = useShotgunGameMetadata(currentGame);

  const onSelectScorer = (game: IGroupGameGame) => async () => {
    if (gameToSwap && game.id === gameToSwap.id) {
      setGameToSwap(undefined);
      return;
    }

    if (!!gameToSwap) {
      await swapPlayersSeats(
        currentGame.group.id,
        gameToSwap.id,
        gameToSwap.seat,
        game.id,
        game.seat
      );

      await getAllGames(true);

      setGameToSwap(undefined);

      return;
    }

    setGameToSwap(game);
  };

  const save = async () => {
    const eventStartingHole = isShotgun ? startingHole + 1 : 1;

    navigate(`/event-scores/${eventId}/round/${roundId}/hole/${eventStartingHole}/`);
  };

  const isPlayerToSwap = (game: IGroupGameGame) => gameToSwap && game.id === gameToSwap.id;

  return (
    <div className="score-route set-official-scorer">
      <h2>SETUP THE MONEY BALL ORDER</h2>

      <div className="scorers">
        {groupGames.map((game, index) => (
          <ScorersContainer>
            <div className="game-index">{index + 1}</div>

            <Scorer item={game.enrollment} key={`scorer-${game.enrollment.id}`}>
              <Button
                variant={isPlayerToSwap(game) ? 'contained' : 'outlined'}
                color="primary"
                className="select-scorer-button"
                onClick={onSelectScorer(game)}
              >
                {isPlayerToSwap(game) ? 'STAY PUT' : gameToSwap ? 'MOVE' : 'SWAP'}
              </Button>
            </Scorer>
          </ScorersContainer>
        ))}
      </div>

      <Button variant="contained" color="primary" className="save-scorer-button" onClick={save}>
        SAVE
      </Button>
    </div>
  );
};

export default SetMoneyBallOrder;
